import gql from 'graphql-tag'
export interface LoanInput {
  id: string
}

export interface Loan {
  loan: IFragmentBasicLoanFields | null
}

export interface SelectionOnState {
  amount: number | null
  interest: number | null
  loanedAmount: number | null
}

export interface SelectionOnCreditor {
  id: string
  name: string | null
}

export interface SelectionOnDebtors {
  id: string
  name: string | null
}

export interface IFragmentSpreadOnInitTransaction {
  interest: number
  amount: number
}

export interface SelectionOnPayers {
  id: string
  name: string | null
}

export interface IFragmentSpreadOnPaymentTransaction {
  amount: number
  payers: Array<SelectionOnPayers>
}

export interface SelectionOnTransactions {
  __typename: 'InitTransaction' | 'CloseTransaction' | 'PaymentTransaction'
  id: string
  createdOn: any
  description: string | null
}

export interface IFragmentBasicLoanFields {
  id: string
  description: string | null
  createdOn: any | null
  startedOn: any | null
  completedOn: any | null
  interval: IntervalType | null
  state: SelectionOnState
  creditor: SelectionOnCreditor
  debtors: Array<SelectionOnDebtors>
  transactions: Array<
    SelectionOnTransactions &
      Partial<IFragmentSpreadOnInitTransaction> &
      Partial<IFragmentSpreadOnPaymentTransaction>
  >
}

export enum IntervalType {
  ANNUALY = 'ANNUALY',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY'
}

export default gql`
  query Loan($id: ID!) {
    loan(id: $id) {
      ...BasicLoanFields
    }
  }

  fragment BasicLoanFields on Loan {
    id
    description
    createdOn
    startedOn
    completedOn
    interval
    state {
      amount
      interest
      loanedAmount
    }
    creditor {
      id
      name
    }
    debtors {
      id
      name
    }
    transactions {
      __typename
      id
      createdOn
      description

      ... on InitTransaction {
        interest
        amount
      }

      ... on PaymentTransaction {
        amount
        payers {
          id
          name
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/queries/loan.tsx